export interface BatchTrcContentDetailRegisterRequest {
  startNumFrom: string
  startNumTo: string
  materialFormat: string
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  registeredContentDetailType: string
  registeredAuthorityType: string
  contentDetailTitleFile: string
  contentDetailDisplayAuthorFile: string
  memo: string
  batchType: string
}

export function BatchTrcContentDetailRegisterRequestToJSON(
  value: BatchTrcContentDetailRegisterRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    material_format: value.materialFormat,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    convert_kana_to_half: value.convertKanaToHalf,
    registered_content_detail_type: value.registeredContentDetailType,
    registered_authority_type: value.registeredAuthorityType,
    content_detail_title_file: value.contentDetailTitleFile,
    content_detail_display_author_file: value.contentDetailDisplayAuthorFile,
    memo: value.memo,
    batch_type: value.batchType
  }
}
